import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

interface EditPainModalProps {
    isOpen: boolean;
    onClose: () => void;
    painDetails: { P: string; Q: string; R: string; S: string; T: string };
    setPainDetails: (painDetails: any) => void;
    onSave: () => void;
}

const EditPainModal: React.FC<EditPainModalProps> = ({ isOpen, onClose, painDetails, setPainDetails, onSave }) => {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" open={isOpen} onClose={onClose} className="fixed inset-0 z-[999] overflow-y-auto bg-black/60">
                <div className="flex min-h-screen items-center justify-center px-4">
                    <Dialog.Panel className="panel my-8 w-full max-w-lg overflow-hidden rounded-lg p-2 bg-white dark:bg-gray-900 shadow-lg">
                        {/* Header Modal */}
                        <div className="flex items-center justify-between bg-[#fbfbfb] dark:bg-gray-800 px-4 pt-3 pb-0 border-b dark:border-gray-700">
                            <h5 className="text-lg font-bold text-gray-800 dark:text-white">Edit Informasi Nyeri</h5>
                            <button type="button" className="text-red-500 dark:text-red-400 hover:text-red-700 dark:hover:text-red-500 text-xl" onClick={onClose}>
                                ❌
                            </button>
                        </div>

                        {/* Body Modal */}
                        <div className="p-5">
                            <div className="space-y-4">
                                {["P", "Q", "R", "S", "T"].map((key) => (
                                    <div key={key} className="flex justify-between items-center">
                                        <label className="w-10 font-semibold text-gray-700 dark:text-gray-300">{key}</label>
                                        <input
                                            className="flex-1 border p-2 rounded outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-800 dark:text-white dark:border-gray-700 dark:focus:ring-blue-500"
                                            value={painDetails[key] || ""}
                                            onChange={(e) => setPainDetails({ ...painDetails, [key]: e.target.value })}
                                        />
                                    </div>
                                ))}
                            </div>

                            {/* Footer Modal */}
                            <div className="mt-6 flex justify-end space-x-3">
                                <button className="bg-gray-400 dark:bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-500 dark:hover:bg-gray-600 transition" onClick={onClose}>
                                    Cancel
                                </button>
                                <button className="bg-blue-600 dark:bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700 dark:hover:bg-blue-600 transition" onClick={onSave}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </Dialog.Panel>
                </div>
            </Dialog>
        </Transition>
    );
};

export default EditPainModal;
